import { isPlatformBrowser } from '@angular/common';
import { Injectable, PLATFORM_ID, inject } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { environment } from '../../environments/environment';
import { filter } from 'rxjs/operators';

declare let gtag: Function;

@Injectable({
  providedIn: 'root'
})
export class GoogleAnalyticsService {

  private readonly platformId = inject(PLATFORM_ID);

  constructor(private router: Router) {}

  
  public track() {
    if (!this.shouldSend()) {
      return;
    }
    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
      this.emitPageview(event.urlAfterRedirects);
    });
  }

  public event(eventName: string, opts?: { [key: string]: any }) {
    if (!this.shouldSend()) {
      return;
    }
    gtag("event", eventName, {
      ...opts,
    });
  }


  public emitPageview(url: string) {
    if (!this.shouldSend()) {
      return;
    }

    this.event('page_view', {
      page_title: document.title,
      page_location: location.href
    })
  }


  private shouldSend(): boolean {
    // Never while prerendering: gtag, document and location only exist in the browser.
    return environment.enableGoogleAnalytics && isPlatformBrowser(this.platformId);
  }

}